import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

import {inject, computed, ref} from 'vue';
import {storeToRefs} from "pinia";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import ProductCard from './ProductCards/ProductCard.vue'

import {SmartSearchConfigInterface} from '@/core/types'
import NoResultsInfo from "@/components/SerpPage/ResultsInfoWrapper/NoResultsInfo.vue";
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const ComponentName = 'productCard'
// eslint-disable-next-line no-prototype-builtins

export default /*#__PURE__*/_defineComponent({
  __name: 'ListingContainer',
  setup(__props) {

const SmartSearchConfig = ref(inject<SmartSearchConfigInterface>('SmartSearchConfig')!)
const customComponents = SmartSearchConfig.value.serp.customComponents
const {smallDevice, mediumDevice, largeDevice, extraLargeDevice} = SmartSearchConfig.value.serp.gridSettings.column

const computedClass = computed(() => {
  return [
    `q-row-cols-xl-${extraLargeDevice}`,
    `q-row-cols-lg-${largeDevice}`,
    `q-row-cols-md-${mediumDevice}`,
    `q-row-cols-${smallDevice}`,
    'q-row',
    'q-m-1'
  ];
});

const hasCustomComponent = customComponents.hasOwnProperty(ComponentName) ? customComponents[ComponentName] : null;
const serpStore = useSerpResultsStore();
const {getProducts} = storeToRefs(serpStore)



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "ListingContainer",
    class: _normalizeClass(computedClass.value)
  }, [
    _createVNode(NoResultsInfo),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getProducts), (product) => {
      return (_openBlock(), _createBlock(ProductCard, {
        product: product,
        key: product.id,
        component: _unref(hasCustomComponent)
      }, null, 8, ["product", "component"]))
    }), 128))
  ], 2))
}
}

})